var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("collapse-transition", { attrs: { appear: _vm.appear } }, [
    _c("ul", { class: _vm.classes }, [
      _c(
        "li",
        {
          on: {
            contextmenu: function($event) {
              $event.stopPropagation()
              return _vm.handleContextmenu(_vm.data, $event)
            },
            selectstart: function($event) {
              $event.stopPropagation()
              return _vm.handlePreventSelect(_vm.data, $event)
            }
          }
        },
        [
          _c(
            "span",
            { class: _vm.arrowClasses, on: { click: _vm.handleExpand } },
            [
              _vm.showArrow
                ? _c("Icon", {
                    attrs: {
                      type: _vm.arrowType,
                      custom: _vm.customArrowType,
                      size: _vm.arrowSize
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.showLoading
                ? _c("Icon", {
                    staticClass: "ivu-load-loop",
                    attrs: { type: "ios-loading" }
                  })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _vm.showCheckbox
            ? _c("Checkbox", {
                attrs: {
                  value: _vm.data.checked,
                  indeterminate: _vm.data.indeterminate,
                  disabled: _vm.data.disabled || _vm.data.disableCheckbox
                },
                nativeOn: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.handleCheck.apply(null, arguments)
                  }
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "span",
            { class: _vm.titleClasses, on: { click: _vm.handleClickNode } },
            [
              _vm.data.render
                ? _c("Render", {
                    attrs: {
                      render: _vm.data.render,
                      data: _vm.data,
                      node: _vm.node
                    }
                  })
                : _vm.isParentRender
                ? _c("Render", {
                    attrs: {
                      render: _vm.parentRender,
                      data: _vm.data,
                      node: _vm.node
                    }
                  })
                : [_vm._v(_vm._s(_vm.data.title))]
            ],
            2
          ),
          _vm._v(" "),
          _vm._l(_vm.children, function(item, i) {
            return _vm.data.expand
              ? _c("Tree-node", {
                  key: i,
                  attrs: {
                    appear: _vm.appearByClickArrow,
                    data: item,
                    multiple: _vm.multiple,
                    "show-checkbox": _vm.showCheckbox,
                    "children-key": _vm.childrenKey
                  }
                })
              : _vm._e()
          })
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5daa0c29", { render: render, staticRenderFns: staticRenderFns })
  }
}